<template>
  <div :class="twMerge(typeof $attrs.class === 'string' ? $attrs.class : undefined)">
    <div class="flex items-center px-4 py-3">
      <div class="checkbox-wrapper" :class="`checkbox-${theme}`">
        <input
          :id="label"
          v-model="checked"
          type="checkbox"
          :required="required"
          class="cursor-pointer"
        />
      </div>
      <label :for="label" class="ml-3 cursor-pointer text-base leading-none text-black">
        {{ label }}
      </label>
    </div>

    <span
      v-if="description"
      :class="twMerge(theme !== THEMES.RDK ? 'text-sm' : 'text-sm lg:text-base')"
    >
      {{ description }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { THEMES } from '../../types/themes'
import { twMerge } from 'tailwind-merge'

const props = withDefaults(
  defineProps<{
    label: string
    modelValue: boolean
    description?: string
    required?: boolean
    theme?: THEMES
  }>(),
  {
    theme: THEMES.DEFAULT,
  },
)

const emit = defineEmits(['update:modelValue'])

const checked = useVModel(props, 'modelValue', emit)
</script>

<style scoped>
.checkbox-djurens_ratt.checkbox-wrapper,
.checkbox-default.checkbox-wrapper {
  --borderColor: #00b4d2;
  --borderWidth: 2px;
  --mainColor: #00b4d2;
  --checkColor: #fff;
  --backgroundColor: #fff;
}

.checkbox-rdk.checkbox-wrapper {
  --mainColor: #7a54c3;
  --checkColor: #fff;
  --borderColor: #7a54c3;
  --borderWidth: 2px;
  --backgroundColor: transparent;
}

.checkbox-wrapper input[type='checkbox'] {
  -webkit-appearance: none;
  appearance: none;
  vertical-align: middle;
  background: var(--backgroundColor);
  border-radius: 5px;
  display: inline-block;
  border: var(--borderWidth) solid var(--borderColor);
  width: 27px;
  height: 27px;
  position: relative;
}

.checkbox-wrapper input[type='checkbox']:checked {
  background: var(--mainColor);
}

.checkbox-wrapper input[type='checkbox']:after {
  content: '';
  position: absolute;
  background: var(--checkColor);
  width: 9px;
  height: 3px;
  top: 13px;
  left: 6px;
  transform-origin: left center;
  border-radius: 4px;
}

.checkbox-wrapper input[type='checkbox']:checked:after {
  width: calc(var(--borderWidth) * 8);
  transform: rotate(-45deg) translateY(calc(var(--borderWidth) * 2)) scaleX(1);
  transition: transform 200ms ease-out 200ms;
}

.checkbox-wrapper input[type='checkbox']:before {
  content: '';
  position: absolute;
  background: var(--checkColor);
  width: 10px;
  height: 3px;
  top: 10px;
  left: 3px;
  transform-origin: left center;
  border-radius: 4px;
}
.checkbox-wrapper input[type='checkbox']:checked:before {
  transform: rotate(45deg) translate(calc(var(--borderWidth) / -2), calc(var(--borderWidth) / -2))
    scaleX(1);
  transition: transform 200ms ease-in;
}

.checkbox-wrapper input[type='checkbox']:before {
  transform: rotate(45deg) translate(calc(var(--borderWidth) / -2), calc(var(--borderWidth) / -2))
    scaleX(0);
  transition: transform 200ms ease-in 200ms;
}
.checkbox-wrapper input[type='checkbox']:after {
  width: calc(var(--borderWidth) * 5);
  transform: rotate(-45deg) translateY(calc(var(--borderWidth) * 2)) scaleX(0);
  transform-origin: left center;
  transition: transform 200ms ease-in;
}

.checkbox-wrapper input[type='checkbox']:focus {
  outline: none !important;
  box-shadow: none !important;
}
</style>
